export class LevelIIState {
  symbol = "";
  openTimeAndSales = false;
}
